export const MadeByShort = () => {
  return (
    <div className="text-center" style={{ fontSize: 10, color: "lightgray" }}>
      by{" "}
      <a href="https://partsfindersoftware.com" target="_blank" className="text-blue-300">
        Parts Finder Software
      </a>
    </div>
  );
};

export const MadeByLong = () => {
  return (
    <div className="text-center" style={{ fontSize: 14, color: "lightgray" }}>
      Software solutions for KTM Dealers
      <div>
        by{" "}
        <a href="https://partsfindersoftware.com" target="_blank" className="text-blue-300">
          Parts Finder Software
        </a>
      </div>
    </div>
  );
};
